export default __webpack_public_path__ + "static/img5-2e1c9db49ef64b499de48ab10ff1c36c.jpg";